<div
  class="modal-header flex items-center space-x-4 px-6 py-5 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
  <div class="text-lg font-semibold text-gray-800">Settings: {{ tableField.name }}</div>
</div>

<div class="modal-body px-6 pt-4 pb-4 bg-white">
  <div class="flex flex-col gap-3 max-h-[calc(100vh-200px)] overflow-y-auto pr-2">
    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700">Field Mode</label>
      <select *ngIf="tableField.data_type === 'dropdown'" [ngModel]="false" [disabled]="true"
        class="border border-gray-300 rounded-lg p-2 bg-gray-100 text-gray-500 cursor-not-allowed">
        <option [value]="false">Read-only</option>
      </select>
      <select *ngIf="tableField.data_type !== 'dropdown'" [(ngModel)]="tableField.editable"
        (ngModelChange)="tableField.editable = $event === 'true' ? true : false;"
        class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm">
        <option [value]="true">Editable</option>
        <option [value]="false">Read-only</option>
      </select>
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700">Column Required</label>
      <div class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 transition-all shadow-sm">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="tableField.required"
            class="border border-gray-300 rounded h-4 w-4 hover:border-gray-400 focus:ring-2 focus:ring-blue-200 transition-all">
          <span class="ml-2 text-sm text-gray-700">Required field</span>
        </div>
        <small class="text-gray-500 ml-6">Make this field mandatory</small>
      </div>
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700">Data Type</label>
      <select [(ngModel)]="tableField.data_type" (ngModelChange)="onDataTypeChange($event)"
        class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm">
        <option value="alphanumeric">Alphanumeric</option>
        <option value="numeric">Numeric</option>
        <option value="dropdown">Dropdown List</option>
      </select>
    </div>

    <div class="flex flex-col gap-1.5" *ngIf="tableField.data_type === 'numeric'">
      <label class="text-sm font-semibold text-gray-700">Value Range</label>
      <div class="flex gap-4">
        <div class="flex-1">
          <label class="text-xs text-gray-600">Minimum Value</label>
          <input type="number" [(ngModel)]="tableField.min_value"
            class="w-full bg-transparent border border-gray-300 p-2 rounded-lg hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            min="0" value="0">
        </div>
        <div class="flex-1">
          <label class="text-xs text-gray-600">Maximum Value</label>
          <input type="number" [(ngModel)]="tableField.max_value"
            class="w-full bg-transparent border border-gray-300 p-2 rounded-lg hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            min="0">

        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1.5" *ngIf="tableField.data_type === 'alphanumeric'">
      <label class="text-sm font-semibold text-gray-700">Max Length</label>
      <input type="number" [(ngModel)]="tableField.max_characters"
        class="flex-grow bg-transparent border border-gray-300 p-2 rounded-lg hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm"
        min="1" value="50">
      <small class="text-gray-500">Maximum number of characters allowed in this field</small>
    </div>

    <div class="flex flex-col gap-1.5" *ngIf="tableField.data_type === 'numeric'">
      <label class="text-sm font-semibold text-gray-700">Column Totals</label>
      <select [(ngModel)]="tableField.enable_totals"
        class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm">
        <option [value]="false">Disabled</option>
        <option [value]="true">Enabled</option>
      </select>
      <small class="text-gray-500">Enable to show column totals at the bottom of the table</small>
    </div>

    <div class="flex flex-col gap-1.5" *ngIf="tableField.data_type === 'numeric'">
      <label class="text-sm font-semibold text-gray-700">Row Totals</label>
      <select [(ngModel)]="tableField.enable_row_totals"
        class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm">
        <option [value]="false">Disabled</option>
        <option [value]="true">Enabled</option>
      </select>
      <small class="text-gray-500">Enable to add a new cell in the same row showing the total of all numeric values in
        that row</small>
    </div>

    <ng-container *ngIf="tableField.data_type === 'dropdown'">
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-semibold text-gray-700">Options Mode</label>
        <select [(ngModel)]="tableField.use_option_keys" (ngModelChange)="onUseOptionKeysChange($event)"
          class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm">
          <option [value]="false">Labels only</option>
          <option [value]="true">Labels and values</option>
        </select>
        <small class="text-gray-500">Labels only stores the display text. Labels and values stores a separate key per
          option.</small>
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-semibold text-gray-700">Placeholder</label>
        <input type="text" [(ngModel)]="tableField.placeholder"
          class="border border-gray-300 rounded-lg p-2 hover:border-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm"
          placeholder="Select...">
        <small class="text-gray-500">Optional. Text shown when no option is selected. Defaults to "Select...".</small>
      </div>

      <div class="flex flex-col gap-1.5">
        <div class="flex items-center justify-between">
          <label class="text-sm font-semibold text-gray-700">Options</label>
          <button type="button" (click)="addOption()" [disabled]="haveEmptyOption()"
            class="secondary-button text-white py-2 flex flex-row items-center justify-center h-8 px-3">
            <lucide-icon name="plus" class="h-5 w-5"></lucide-icon>
            <span class="ml-2">Option</span>
          </button>
        </div>

        <div class="rounded-lg border border-gray-300 mt-1 p-2 bg-gray-50"
          *ngIf="tableField.options && tableField.options.length">
          <div class="overflow-y-auto max-h-60 pr-1">
            <div class="flex flex-row justify-start gap-3 mb-2"
              *ngFor="let option of tableField.options; let j = index; trackBy: trackByIndex">
              <div class="relative flex-1">
                <div class="flex items-center space-x-2">
                  <div class="flex-1" *ngIf="tableField.use_option_keys">
                    <label class="block text-xs text-gray-700 mb-1">Key {{ j + 1 }}</label>
                    <input type="text" placeholder="Enter key {{ j + 1 }}" [(ngModel)]="tableField.option_keys![j]"
                      class="block w-full pl-3 pr-3 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 sm:text-sm rounded-md">
                  </div>

                  <div class="flex-1">
                    <label class="block text-xs text-gray-700 mb-1">
                      {{ tableField.use_option_keys ? 'Value' : 'Label' }} {{ j + 1 }}
                    </label>
                    <input type="text"
                      [placeholder]="(tableField.use_option_keys ? 'Enter value ' : 'Enter label ') + (j + 1)"
                      [(ngModel)]="tableField.options[j]"
                      class="block w-full pl-3 pr-3 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 sm:text-sm rounded-md">
                  </div>

                  <div class="flex items-end">
                    <button type="button" (click)="deleteOption(j)"
                      class="text-red-500 hover:text-red-700 mb-[2px] pt-[20px]">
                      <lucide-icon name="trash-2" class="h-5 w-5"></lucide-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <small class="text-gray-500" *ngIf="!tableField.options?.length">Add options that users can select in this
          column.</small>
      </div>
    </ng-container>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700">Column Size</label>
      <div class="flex w-full group">
        <input type="text" [(ngModel)]="tableField.size"
          class="flex-grow bg-transparent border border-gray-300 border-r-0 p-2 rounded-l-lg hover:border-gray-400 focus:border-gray-400 focus:ring-2 focus:ring-blue-200 transition-all shadow-sm"
          placeholder="100" />
        <span
          class="inline-flex items-center px-3 border border-l-0 border-gray-300 bg-gray-50 text-sm font-medium text-gray-400 rounded-r-lg transition-all group-hover:border-gray-400 group-focus-within:border-gray-400">
          PX
        </span>
      </div>
      <small class="text-gray-500">Enter the table size in pixels as an integer, e.g., '100'.</small>
    </div>
  </div>
</div>

<div
  class="modal-footer flex justify-end space-x-3 p-6 bg-gradient-to-r from-white to-gray-50 border-t border-gray-200">
  <button type="button" (click)="close()"
    class="secondary-button h-9 flex flex-row text-sm items-center justify-center px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all"
    aria-label="Close settings">
    <lucide-angular name="x" class="h-4 w-4 mr-2"></lucide-angular>
    <span>Close</span>
  </button>
</div>
